import { ReactElement, useState } from 'react';
import { GreenCheckmarkIcon } from '../icons/icons';
import './IconTextGroup.css';

export enum IconTextGroupPropsIconPosition {
    Start = 'start',
    End = 'end',
}

interface IconTextGroupProps {
    text: string | null;
    avatarsOrIcons?: Array<ReactElement>;
    flaggedAvatarIndicator?: ReactElement;
    unflaggedAvatarIndicator?: ReactElement;
    isClickable?: boolean;
    hasBorder?: boolean;
    classes?: string;
    dataTestId?: string;
    dataClick?: {
        dataId: string;
        onClick: (dataId: string, filter?: (data: any) => any) => void;
    };
    classesForIcon?: string;
    classesForText?: string;
    selected?: boolean;
    iconPosition?: IconTextGroupPropsIconPosition;
}

const IconTextGroup = ({
    avatarsOrIcons,
    text,
    flaggedAvatarIndicator = <GreenCheckmarkIcon />,
    unflaggedAvatarIndicator,
    isClickable = false,
    hasBorder,
    classes,
    dataTestId,
    dataClick,
    classesForIcon,
    classesForText,
    selected = false,
    iconPosition = IconTextGroupPropsIconPosition.Start,
}: IconTextGroupProps) => {
    const [isSelected, setIsSelected] = useState(selected);

    const getAvatarsOrIcons = () => {
        if (!avatarsOrIcons || avatarsOrIcons.length === 0) {
            return null;
        }

        return (
            <div
                className={`susy-icon-text-group-imgs ${classesForIcon ?? ''}`}
            >
                {avatarsOrIcons.map((avatarOrIcon, index) => (
                    <div
                        key={index}
                        className='susy-icon-text-group-imgs-single'
                    >
                        {avatarOrIcon}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div
            className={`susy-icon-text-group ${hasBorder ? 'bordered' : ''} ${
                classes ?? ''
            } icon-${iconPosition}`}
            data-testid={dataTestId}
            onClick={() => {
                if (isClickable) {
                    setIsSelected(!isSelected);
                    dataClick?.onClick(dataClick.dataId);
                }
            }}
        >
            {avatarsOrIcons &&
                iconPosition === IconTextGroupPropsIconPosition.Start &&
                getAvatarsOrIcons()}

            <div
                className={`susy-icon-text-group-text ${classesForText ?? ''}`}
            >
                {text}
            </div>

            {avatarsOrIcons &&
                iconPosition === IconTextGroupPropsIconPosition.End &&
                getAvatarsOrIcons()}

            {isSelected && <div className='ml-3'>{flaggedAvatarIndicator}</div>}

            {!isSelected && unflaggedAvatarIndicator && (
                <div className='ml-3'>{unflaggedAvatarIndicator}</div>
            )}
        </div>
    );
};

export default IconTextGroup;
